import JSZip from "jszip";
import { saveAs } from "file-saver";

function pickSignedUrl(x) {
  if (!x) return "";
  if (typeof x === "string") return x;
  return (
    x?.signed_url?.signed_url ||
    x?.signed_url ||
    x?.url?.signed_url ||
    x?.url ||
    ""
  );
}

export async function DownloadAsZip(items = [], options = {}) {
  const {
    zipName = "generated_images.zip",
    onProgress,
    timeoutMs = 60000,
  } = options;

  const normalized = (items ?? [])
    .map((it, idx) => {
      const signedUrl = pickSignedUrl(it?.signedUrl ?? it?.signed_url ?? it?.data?.signed_url ?? it);
      const filename =
        it?.filename ||
        it?.data?.filename ||
        it?.file_name ||
        it?.name ||
        `generated_${idx + 1}.jpg`;

      return { signedUrl, filename };
    })
    .filter((x) => !!x.signedUrl);

  if (!normalized.length) {
    throw new Error("No downloadable images (missing signed_url).");
  }

  const zip = new JSZip();

  for (let i = 0; i < normalized.length; i++) {
    const { signedUrl, filename } = normalized[i];
    onProgress?.({ done: i, total: normalized.length, filename });

    // fetch with timeout
    const controller = new AbortController();
    const t = setTimeout(() => controller.abort(), timeoutMs);

    let res;
    try {
      res = await fetch(signedUrl, { signal: controller.signal, mode: "cors" });
    } finally {
      clearTimeout(t);
    }

    if (!res.ok) throw new Error(`Failed to fetch ${filename} (${res.status})`);

    const blob = await res.blob();
    zip.file(filename, blob);
  }

  onProgress?.({ done: normalized.length, total: normalized.length });

  const zipBlob = await zip.generateAsync({ type: "blob" });
  saveAs(zipBlob, zipName);
}
